import OnboardingRouteContainer from "@features/auth/components/OnboardingRouteContainer";
import DocumentTitle from "components/DocumentTitle";
import { Stack } from "expo-router";

const OnboardingRoute = () => {
	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title="Onboarding" />
			<OnboardingRouteContainer />
		</>
	);
};

export default OnboardingRoute;
